function Obj2StrArr(obj, path = '') {
    let resp = {};
    for (let [p, data] of Object.entries(obj)) {
        p = `${path}/${p}`;
        if (!Array.isArray(data) && typeof data === 'object' && data !== null)
            Object.assign(resp, Obj2StrArr(data, p));
        else
            resp[p] = data;
    }
    return resp;
}

export default Obj2StrArr;
